<!-- fallow-ignore-file complexity -->
<div
	class="filter-card"
	[class.card--selected]="isSelected()"
	[class.filter-card--dropdown]="resolvedControlType() === ControlType.Dropdown"
	[class.filter-card--date-range]="resolvedControlType() === ControlType.DateRange"
	[attr.data-testid]="testId() ?? null"
	(click)="onCardClick()"
>
	@if (isDebugMode()) {
		<div
			class="debug-info"
			style="
				position: absolute;
				top: 4px;
				left: 4px;
				z-index: 100;
				background: rgba(0, 0, 0, 0.75);
				color: #fff;
				padding: 4px 8px;
				font-size: 10px;
				font-family: 'SF Mono', Monaco, monospace;
				border-radius: 4px;
				backdrop-filter: blur(4px);
				display: flex;
				gap: 8px;
				align-items: center;
			"
		>
			<span style="color: #4fc3f7">{{ cardId() }}</span>
			<span
				style="
					background: #ff9800;
					padding: 1px 6px;
					border-radius: 3px;
					font-size: 9px;
					text-transform: uppercase;
				"
				>filter</span
			>
		</div>
	}

	@if (resolvedControlType(); as controlType) {
	@switch (controlType) {
		@case (ControlType.Dropdown) {
			@if (effectiveTitle() || effectiveSubtitle() || effectiveIcon()) {
				<div class="card-header">
					<div class="card-icon-title-wrapper">
						@if (effectiveIcon()) {
							<mat-icon
								class="material-symbols-outlined card-icon"
								>{{ effectiveIcon() }}</mat-icon
							>
						}
						@if (effectiveTitle()) {
							<h2 class="card-title">{{ effectiveTitle() }}</h2>
						}
					</div>
					@if (effectiveSubtitle()) {
						<div class="card-subtitle">
							{{ effectiveSubtitle() }}
						</div>
					}
				</div>
			}
			<div
				class="filter-card__control filter-card__control--dropdown"
				[class.filter-card__control--selected]="isSelected()"
			>
				@if (dimensionFilterData(); as dropdownData) {
					<jepto-dimension-filter-dropdown
						[filterData]="dropdownData"
						[themeMode]="themeMode()"
						[themeConfig]="themeConfig()"
						[menuDisabled]="isEditMode()"
						[testId]="testId() ? testId() + '-dropdown' : undefined"
						(selectionChange)="onDimensionSelection($event)"
					/>
				}
				@if (isSelected()) {
					<div class="card-action-buttons filter-card__dropdown-action-buttons">
						<button
							type="button"
							class="card-action-btn"
							aria-label="Edit card"
							(click)="onEditCardClick($event)"
						>
							<span class="icon-edit-2"></span>
						</button>
						<button
							type="button"
							class="card-action-btn"
							aria-label="More options"
							[matMenuTriggerFor]="cardMenu"
							(click)="$event.stopPropagation()"
						>
							<span class="icon-more-vertical"></span>
						</button>
					</div>
				}
			</div>
		}
		@case (ControlType.DateRange) {
			@if (effectiveTitle() || effectiveSubtitle()) {
				<div class="card-header">
					@if (effectiveTitle()) {
						<div class="card-icon-title-wrapper">
							@if (effectiveIcon()) {
								<mat-icon
									class="material-symbols-outlined card-icon"
									>{{ effectiveIcon() }}</mat-icon
								>
							}
							<h2 class="card-title">{{ effectiveTitle() }}</h2>
						</div>
					}
					@if (effectiveSubtitle()) {
						<div class="card-subtitle">
							{{ effectiveSubtitle() }}
						</div>
					}
				</div>
			}
			<div
				class="filter-card__control filter-card__control--date-range"
				[class.filter-card__control--selected]="isSelected()"
			>
				@if (isEditMode()) {
					<jepto-date-range-picker
						[themeMode]="themeMode()"
						[themeConfig]="themeConfig()"
						[dateRange]="dateRangeForDisplay()"
						[displayOnly]="true"
						[presetInLabel]="true"
						[syncFilterService]="false"
					/>
				} @else {
					<jepto-date-range-picker
						[themeMode]="themeMode()"
						[themeConfig]="themeConfig()"
						[dateRange]="dateRangeForDisplay()"
						[presetInLabel]="true"
						[syncFilterService]="false"
						(dateRangeChange)="onDateRangeChange($event)"
					/>
				}
			</div>
		}
		@case (ControlType.Search) {
			<div
				class="filter-card__control filter-card__control--search"
				[class.filter-card__control--selected]="isSelected()"
			>
				@if (showCreateSearchEmptyState()) {
					<div class="card-create-empty-state">
						<div class="card-create-empty-state__title">
							Create Search Filter
						</div>
						<div class="card-create-empty-state__line">
							Pick a dimension under Data to build your search
							filter.
						</div>
					</div>
				} @else {
					<div
						class="search-filter-field"
						[class.search-filter-field--dark]="
							activeThemeMode() === 'dark'
						"
						[attr.data-testid]="
							testId() ? testId() + '-search' : null
						"
						(mousedown)="$event.stopPropagation()"
						(click)="$event.stopPropagation()"
					>
						<div class="search-filter-field__icon-wrap">
							<span
								class="search-filter-field__glyph icon-search"
								aria-hidden="true"
							></span>
						</div>
						<div class="search-filter-field__field">
							<label
								class="search-filter-field__label"
								[attr.for]="
									testId() ? testId() + '-search-input' : null
								"
								>{{ searchLabel() }}</label
							>
							<jepto-ui-input
								class="search-filter-field__input"
								[label]="''"
								[placeholder]="searchPlaceholder()"
								[inputId]="
									testId() ? testId() + '-search-input' : undefined
								"
								appearance="fill"
								[floatLabel]="'never'"
								[applicationFill]="true"
								[applicationFillBackground]="'transparent'"
								[applicationFillDark]="
									activeThemeMode() === 'dark'
								"
								[readonly]="searchInputReadonly()"
								[tabIndex]="searchInputReadonly() ? -1 : 0"
								[ngModel]="searchQuery()"
								(ngModelChange)="onSearchQueryChange($event)"
								[testId]="
									testId() ? testId() + '-search-input' : ''
								"
							/>
						</div>
					</div>
				}
			</div>
		}
	}

		@if (isSelected() && controlType !== ControlType.Dropdown) {
			<div class="card-action-buttons">
				<button
					type="button"
					class="card-action-btn"
					aria-label="Edit card"
					(click)="onEditCardClick($event)"
				>
					<span class="icon-edit-2"></span>
				</button>
				<button
					type="button"
					class="card-action-btn"
					aria-label="More options"
					[matMenuTriggerFor]="cardMenu"
					(click)="$event.stopPropagation()"
				>
					<span class="icon-more-vertical"></span>
				</button>
			</div>
		}
	} @else {
		<div
			class="filter-card__control filter-card__control--pending"
			role="status"
			aria-busy="true"
			aria-label="Loading filter"
		>
			<div class="filter-card__pending-shimmer"></div>
		</div>
	}

	<mat-menu #cardMenu="matMenu" panelClass="card-actions-menu">
		<ng-template matMenuContent>
			<button mat-menu-item (click)="editCard.emit()">Edit</button>
			<button mat-menu-item (click)="duplicateCard.emit()">
				Duplicate
			</button>
			<button mat-menu-item disabled type="button">Save card</button>
			<button
				mat-menu-item
				class="card-menu-item--danger"
				(click)="deleteCard.emit()"
			>
				Delete
			</button>
		</ng-template>
	</mat-menu>
</div>
